function o(n){return typeof n=="object"&&n!=null}export{o as a};